import {
  AbstractSectionName,
  AspectRatio,
  DefaultSectionName,
  FIELD_ROLES,
  ImageResolution,
  SectionName,
} from './types';

export const AI_IMAGE_GENERATION_SERVERLESS_BASE_URL =
  '/_serverless/ai-image-generation/';

export const ScenePromptIds: Record<SectionName, string> = {
  [DefaultSectionName.WELCOME]: 'cc58c584-f85a-4033-b086-975232bd17e0',
  [DefaultSectionName.ABOUT]: '12e52257-3ec3-48cf-80db-26b8f552e9a6',
  [DefaultSectionName.GALLERY]: '38275641-58b5-45a2-857c-a27c96fa90ec',
  [DefaultSectionName.INSTAGRAM]: '38275641-58b5-45a2-857c-a27c96fa90ec',
  [DefaultSectionName.GENERAL]: '38275641-58b5-45a2-857c-a27c96fa90ec',
  [DefaultSectionName.TEAM]: '0821faff-a3ff-4014-b82c-0b5bc2a8cbdd',
  [DefaultSectionName.TESTIMONIALS]: '0f5308b2-1280-4182-8644-e35aeb065ffd',
  [AbstractSectionName.ABSTRACT]: '38275641-58b5-45a2-857c-a27c96fa90ec',
};

export const DEFAULT_STRUCTURE_ID = 'bb28dbfc-cc91-479a-9cb5-b6a95f540c23';
export const TEAM_MEMBERS_STRUCTURE_ID = '76a9c964-0e79-4169-b141-47611fc794ad';

export const SD_CORE_IMAGE_GENERATION_PROMPT_ID =
  '52994cc0-0d0d-405c-bf62-64f521d48c95';

export const FLUX_1_DEV_BLACKLIST_IMAGE_GENERATION_PROMPT_ID =
  '73d4afc6-fcc3-4ab6-a9db-79ea18c84fbf';

export const FLUX_1_DEV_IMAGE_GENERATION_PROMPT_ID =
  '31d38c3e-8ac2-4867-8940-0fd6a834982b';

export const BusinessTermsBlacklist = [
  '6048aa84be2ee2001584d159',
  '55d4e81833bc9eada9dffd0c',
  '5e8c1d214b7a4200177fd447',
  '6107f122eec48300158889ec',
  '5cf045c939e68000158a4464',
  '5fb61ada96417edd325f09eb',
  '714a7d52812e0df69b1634a3',
  'a4a33900f45ca67110f2dfc4',
  '5eb932ca20ff2b0017946414',
  '2e0d3d3432112b324361895a',
  'a4def3d162781f1e96ee1956',
  '8ad09c40cd032d6f157c3061',
  'c9eddd377e1a194896c3637c',
  '604f0ed3630fc000153966b2',
  '16f33903e614854d62828658',
  '1265240190ad56db08acdf09',
];

export const IMAGE_ASPECT_RATIO_BY_FIELD_ROLE: Record<
  FIELD_ROLES,
  AspectRatio
> = {
  [FIELD_ROLES.CROPTYPE_PORTRAIT]: '4:5',
  [FIELD_ROLES.CROPTYPE_LANDSCAPE]: '16:9',
  [FIELD_ROLES.CROPTYPE_ABSTRACT]: '16:9',
  [FIELD_ROLES.ABSTRACT]: '16:9',
};

export const WIDE_LANDSCAPE_IMAGE_ASPECT_RATIO = '21:9';
export const DEFAULT_IMAGE_ASPECT_RATIO: AspectRatio = '1:1';

export const IMAGE_RESOLUTION_BY_FIELD_ROLE: Record<
  FIELD_ROLES,
  ImageResolution
> = {
  [FIELD_ROLES.CROPTYPE_PORTRAIT]: { height: 2048, width: 1536 },
  [FIELD_ROLES.CROPTYPE_LANDSCAPE]: { height: 1152, width: 2048 },
  [FIELD_ROLES.CROPTYPE_ABSTRACT]: { height: 1152, width: 2048 },
  [FIELD_ROLES.ABSTRACT]: { height: 1152, width: 2048 },
};

export const WIDE_LANDSCAPE_IMAGE_RESOLUTION = { height: 896, width: 2048 };

export const DEFAULT_IMAGE_RESOLUTION = { height: 1024, width: 1024 };

export const AiImageInjectionSectionsBlacklist = ['Footer'];

export const AiImageInjectionBusinessTermsBlacklist = [
  '38194ba8-1218-431c-a007-09c26c75ee0d',
];
